export function expandHexColor(raw, fallback = '#3B82F6') {
    let value = String(raw || '').trim();
    if (!value) return fallback;
    if (!value.startsWith('#')) value = `#${value}`;
    if (/^#[0-9a-fA-F]{3}$/.test(value)) {
        const h = value.slice(1);
        value = `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`;
    }
    if (!/^#[0-9a-fA-F]{6}$/.test(value)) return fallback;
    return value.toUpperCase();
}

export function isHexColor(raw) {
    const value = String(raw || '').trim();
    return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value.startsWith('#') ? value : `#${value}`);
}

export function groupRowStyle(groups) {
    if (!groups?.length) return undefined;
    const colors = groups.map((g) => `${expandHexColor(g.color)}33`);
    if (colors.length === 1) return { backgroundColor: colors[0] };
    return { backgroundImage: `linear-gradient(90deg, ${colors.join(', ')})` };
}
